import React from 'react';
import { SearchInput } from '../../../../components/SearchInput';
import { HotSearches } from '../../../../components/HotSearches';
import { } from '../../../../models/';
import s from './HomeSearchBox.scss';

export const HomeSearchBox = (props: { hotSearch: string[] } ) => {
    const { hotSearch } = props;
    return (
        <div className={s.searchBox}>
            <SearchInput hotSearch={hotSearch}/>
            <HotSearches hotSearch={hotSearch}/>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/pages/HomePageV2/components/HomeSearchBox/index.tsx